import Icon from "../../../components/AppIcon";
import { AvailabilityStatus } from "../types";

interface AvailabilityIndicatorProps {
  status: AvailabilityStatus;
}

const AvailabilityIndicator = ({ status }: AvailabilityIndicatorProps) => {
  const getStatusColor = () => {
    switch (status.status) {
      case "available":
        return "bg-success";
      case "busy":
        return "bg-warning";
      case "away":
        return "bg-muted";
      default:
        return "bg-muted";
    }
  };

  const getStatusIcon = () => {
    switch (status.status) {
      case "available":
        return "CheckCircle2";
      case "busy":
        return "Clock";
      case "away":
        return "Moon";
      default:
        return "Circle";
    }
  };

  return (
    <div className="p-6 rounded-lg border border-border bg-surface">
      <div className="flex items-center gap-3 mb-4">
        <div className="relative">
          <div className={`w-3 h-3 rounded-full ${getStatusColor()} animate-pulse-slow`} />
          <div className={`absolute inset-0 w-3 h-3 rounded-full ${getStatusColor()} animate-ping opacity-75`} />
        </div>
        <h3 className="text-lg font-semibold text-foreground capitalize">
          {status.status === "available" ? "Available Now" : status.status}
        </h3>
      </div>

      <p className="text-sm text-muted-foreground mb-4">{status.message}</p>

      {status.bestTimes.length > 0 && (
        <div className="space-y-2">
          <div className="flex items-center gap-2 text-sm font-medium text-foreground">
            <Icon name={getStatusIcon()} size={16} />
            <span>Best Times to Connect:</span>
          </div>
          <ul className="space-y-1 ml-6">
            {status.bestTimes.map((time, index) => (
              <li key={index} className="text-sm text-muted-foreground">
                • {time}
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
};

export default AvailabilityIndicator;